import {hasAdjacentEnemyUnit} from '../hasAdjacentEnemyUnit';

/**
 * Мешает ли отряд противника достроить крепость: он либо стоит на самой
 * ячейке крепости, либо смежен ей.
 *
 * «Противник» — относительно владельца ГОРОДА, которому принадлежит ячейка
 * крепости (ownerId, см. findOwner): только его собственные отряды стройке не
 * мешают. Та же логика решает судьбу стройки в конце раунда — крепость
 * покидает fortressesUnderConstruction, только когда мешать некому
 * (см. sharedGameStateReducer).
 *
 * @param {string} hexKey - ячейка крепости
 * @param {string} ownerId - id игрока-владельца города с этой ячейкой
 * @param {Array} units - все отряды на поле
 * @returns {boolean}
 */
export const checkIfFortressConstructionBlocked = (hexKey, ownerId, units) => {
  if (!hexKey || !ownerId) {
    return false;
  }

  const allUnits = units || [];
  const hasEnemyUnitOnHex = allUnits.some((unit) => unit.hexKey === hexKey && unit.ownerId !== ownerId);

  return hasEnemyUnitOnHex || hasAdjacentEnemyUnit(hexKey, ownerId, allUnits);
};
